/**
 * El texto de la landing del «Plano Google Maps 7 Dias», en portugués de
 * Portugal y escrito aquí a propósito, no en i18n: la oferta es solo para
 * clientes de Portugal y producto quiere poder revisarla de un vistazo.
 *
 * Sale tal cual del diseño V4 del lienzo «Landing Fundadores PT»
 * (https://claude.ai/artifact/SVYT55Zz8kbqVoJ99RxaVh). Si cambia el diseño, se
 * cambia aquí y en ningún otro sitio. Los importes también: son los del anual
 * vigente para el PRIMER local (el resto paga el precio por escalão), y el
 * checkout no los lee de aquí — los cobra Stripe —, así que solo cambian lo que
 * se pinta.
 */

export const WHATSAPP_AFAQ = 'https://wa.me/34661685505';

export const PRECO = {
  preco: '287 €',
  porMes: '23,92 €',
  comIva: '353,01 €',
};

/**
 * Lo que vale el plan, POR LOCAL, en céntimos: las partidas de «Tudo o que
 * recebes», que sumadas son el «valor total» tachado. Con N locales todo va
 * × N, también los Tapstar (2 por local), y el «Poupas» es ese valor menos lo
 * que cobra la tarifa de N locales.
 *
 * La plataforma es lo que costaría pagar Business mes a mes: 29,90 €/mes (1
 * local, tarifa v4 en Stripe live, comprobado el 29/10) × 12 meses, SIN IVA,
 * como el precio de 287 € con el que se compara (decisión de producto: que
 * cuadre). Un local: 198 € + 358,80 € + 64,90 € = 621,70 €.
 */
export const VALOR_POR_LOCAL = {
  servicos: [14900, null, null, 4900], // null: «Incluído»
  plataformaMensal: 2990,
  meses: 12,
  tapstar: 6490,
  tapstarPorLocal: 2,
};

export const PLATAFORMA_POR_LOCAL = VALOR_POR_LOCAL.plataformaMensal * VALOR_POR_LOCAL.meses;
export const VALOR_TOTAL_POR_LOCAL = VALOR_POR_LOCAL.servicos.reduce((a, c) => a + (c || 0), 0)
  + PLATAFORMA_POR_LOCAL + VALOR_POR_LOCAL.tapstar;

/** «149 €» / «441,32 €»: sin decimales si son redondos, como el resto de la landing. */
export function euros(cents) {
  const decimales = cents % 100 ? 2 : 0;
  return `${(cents / 100).toLocaleString('pt-PT', {
    minimumFractionDigits: decimales, maximumFractionDigits: decimales,
  })} €`;
}

export const NOME_PLANO = 'Plano Google Maps 7 Dias';

export const HERO = {
  eyebrow: 'Plano Google Maps 7 Dias · Exclusivo para clientes Tapstar',
  titulo: 'Recebe mais clientes novos pelo Google Maps, quase sem esforço.',
  texto: 'Em 7 dias otimizamos a tua ficha, respondemos às avaliações pendentes e deixamos as respostas automáticas com SEO local a funcionar. A ti fica a parte fácil: preparar as publicações do mês com a nossa IA, em 30 minutos.',
  chips: ['Tudo pronto em 7 dias', 'Nós fazemos por ti', 'Garantia de 30 dias'],
  porQue: 'Fazemos o trabalho à mão, negócio a negócio. Por isso só abrimos 50 vagas.',
  letraPequena: '287 € por ano · Sem IVA com NIF intracomunitário · 2 meses grátis · Garantia de 30 dias',
  prova: '+1.200 fichas posicionadas no Google com a Tapstar',
};

export const PONTO_DE_PARTIDA = {
  kicker: 'O teu ponto de partida',
  tituloGmb: (palavra) => `Hoje, quando alguém procura ${palavra || 'o teu negócio'} perto de ti`,
  subGmb: (negocio) => (negocio ? `Dados de ${negocio}, atualizados hoje.` : 'Dados da tua ficha, atualizados hoje.'),
  tituloSemGmb: 'Vê em que lugar apareces no Google',
  subSemGmb: 'Procura o teu negócio. Analisamos a tua zona com os dados públicos do Google e mostramos-te onde apareces, quem está à tua frente e o que falta na tua ficha.',
  analisar: 'Analisar',
  analisarNota: 'Grátis · demora uns segundos',
  resultadoAqui: 'O teu resultado aparece aqui.',
  aCalcular: 'A preparar o mapa da tua zona… os números aparecem aqui em poucos minutos.',
  semMapa: 'Ainda não temos o mapa da tua zona. Preparamo-lo no primeiro dia do plano.',
  notaScorePublico: 'Calculado com os dados públicos do Google. Pode variar ligeiramente do valor da tua ficha quando tivermos mais dados.',
  cartoes: {
    posicao: 'o teu lugar no Google Maps, em média na tua zona',
    foraTop: 'fora do top 20 na tua zona',
    porDelante: 'negócios aparecem antes de ti',
    porDelanteSemGmb: 'negócios antes de ti',
    score: 'SEO Score da tua ficha',
    semResposta: 'avaliações por responder',
    total: 'avaliações no Google',
  },
};

export const DIAGNOSTICO = {
  passo1: '1. Procura e escolhe o teu negócio',
  placeholder: 'Nome do teu negócio e cidade',
  semResultados: 'Não encontrámos esse negócio. Experimenta juntar a cidade.',
  eEste: 'É este o teu negócio?',
  aPreparar: 'A preparar a análise deste negócio',
  sim: 'Sim, analisar',
  outro: 'Procurar outro',
  passo2: '2. Confirma a palavra-chave',
  procuramTe: 'Os teus clientes procuram-te por:',
  outraPalavra: 'Outra palavra',
  outraPlaceholder: 'Ex.: restaurante de peixe',
  notaPalavra: 'Escolhemos a categoria principal da tua ficha. Se te procuram por outra coisa, muda-a aqui.',
  verResultado: 'Ver o meu resultado',
  passo3: '3. Análise em direto',
  aAnalisar: 'A analisar a tua zona…',
  checklist: (palavra) => [
    'A encontrar a tua ficha no Google',
    `A procurar ${palavra || 'o teu negócio'} em 49 pontos à tua volta`,
    'A comparar com os negócios à tua frente',
  ],
  semTentativas: 'Já usaste as tuas análises gratuitas. Ligamos a tua ficha contigo no primeiro dia do plano.',
  repetir: 'Analisar outra vez',
  erros: {
    sem_tentativas: 'Já usaste as tuas análises gratuitas.',
    limite_dia: 'Hoje já fizemos muitas análises. Tenta amanhã ou fala com o Afaq.',
    em_curso: 'Já estamos a analisar este negócio. Espera uns segundos.',
    negocio_invalido: 'Não conseguimos encontrar este negócio no Google. Experimenta outro.',
    sem_categoria: 'Escolhe ou escreve uma palavra-chave.',
    diagnostico_desligado: 'A análise não está disponível neste momento.',
    provedor: 'O Google não respondeu. Tenta de novo daqui a pouco.',
    erro: 'A análise falhou do nosso lado. Não gastou nenhuma das tuas tentativas: tenta de novo.',
  },
};

/**
 * La primera pantalla de la landing personalizada (V6, «Versión 6 · Landing
 * personalizada» del lienzo): la oferta con el nombre de SU negocio, su ficha y
 * sus cuatro cifras arriba del todo. De «Quem aparece primeiro» para abajo, la V4.
 */
export const V6 = {
  reservada: (negocio) => `Oferta reservada para ${negocio}`,
  titulo: (nome, negocio) => {
    if (negocio) return `${nome ? `${nome}, mais` : 'Mais'} clientes novos para ${negocio} pelo Google Maps.`;
    return nome ? `${nome}, recebe mais clientes novos pelo Google Maps.` : HERO.titulo;
  },
  dispositivos: (n) => (n === 1
    ? 'O teu Tapstar já envia clientes para esta ficha'
    : `Os teus ${n} Tapstar já enviam clientes para esta ficha`),
  avaliacoes: (n) => `${n.toLocaleString('pt-PT')} ${n === 1 ? 'avaliação' : 'avaliações'}`,
  fotoAlt: (negocio) => `Foto de ${negocio} no Google`,
  // «café em Lisboa» y «café perto de mim» ya dicen dónde; «café» solo, no.
  fichaHoje: (palavra) => {
    if (!palavra) return 'A tua ficha hoje no Google Maps';
    const comLugar = / em |perto de/.test(` ${palavra} `);
    return `A tua ficha hoje, quando procuram ${palavra}${comLugar ? '' : ' perto de ti'}`;
  },
  emQuePesquisa: 'Em que pesquisa queres ver o teu lugar?',
  outraPesquisa: 'Ver noutra pesquisa',
  escolheUma: 'Escolhe uma e vês o resultado aqui em segundos, com os dados públicos do Google.',
  ver: 'Ver',
  potencial: 'Grande potencial de melhoria',
  dadosHoje: 'Dados do Google, atualizados hoje.',
  textoGmb: (pendentes) => `Em 7 dias, o Iván, o nosso especialista em Google Business, trata da tua ficha à mão e responde ${pendentes > 0 ? `às tuas ${pendentes} avaliações pendentes` : 'às avaliações pendentes'}. A ti fica a parte fácil: 30 minutos por mês com a nossa IA.`,
  textoSemGmb: 'Em 7 dias, o Iván, o nosso especialista em Google Business, liga a tua ficha contigo, trata dela à mão e responde às avaliações pendentes. A ti fica a parte fácil: 30 minutos por mês com a nossa IA.',
  precoEyebrow: (negocio) => `${NOME_PLANO} · para ${negocio}`,
  porAno: 'por ano · 2 Tapstar de oferta',
};

export const QUEM_APARECE = {
  titulo: 'Quem aparece primeiro',
  destaque: 'fica com o cliente.',
  texto: 'Os outros nem chegam a ser vistos. É aí que entramos nós.',
};

export const COMO_FUNCIONA = {
  kicker: 'Como funciona',
  titulo: 'O que o Google tem em conta para te recomendar. E quem trata de cada coisa.',
  nos: 'Nós e os teus Tapstar',
  tu: 'Tu · 30 min/mês',
  itens: [
    { titulo: 'Ficha otimizada para atrair clientes novos', quem: 'Nós, em menos de 7 dias', nosso: true, icone: 'ficha' },
    { titulo: 'Avaliações respondidas', quem: 'Nós, todos os dias, em automático', nosso: true, icone: 'respostas' },
    { titulo: 'Avaliações novas todos os meses', quem: 'Oferecemos-te 2 Tapstar, à tua escolha, com o plano.', nosso: true, icone: 'tapstar', imagem: true },
    { titulo: 'Uma publicação por semana', quem: 'Tu, 30 min por mês com a nossa IA', nosso: false, icone: 'publicacao' },
  ],
  resumo: '3 das 4 coisas ficam connosco. A tua parte: 30 minutos por mês.',
  escolhe: 'Escolhe 2 Tapstar destes modelos, os que mais gostares.',
};

export const TUDO = {
  kicker: NOME_PLANO,
  titulo: 'Tudo o que recebes',
  nosTitulo: 'O que fazemos nós',
  nosNota: '· uma vez, em menos de 7 dias',
  nos: [
    { titulo: 'Ficha otimizada para a tua zona', texto: 'O Google passa a saber o que ofereces e a quem te recomendar' },
    { titulo: 'Respostas automáticas com SEO local', texto: 'Cada avaliação nova trabalha as tuas palavras-chave' },
    { titulo: 'Ficha em dia desde o 1.º dia', texto: 'Respondemos às avaliações pendentes no primeiro dia' },
    { titulo: 'Análise da concorrência', texto: 'Quem te ganha no Google e porquê' },
  ],
  tuTitulo: 'O que tens tu',
  tuNota: '· 12 meses',
  plataforma: {
    titulo: 'MyTapstar Business durante 12 meses',
    texto: 'O mesmo painel onde geres os teus Tapstar, com tudo desbloqueado. Pagas 10 meses, 2 grátis.',
  },
  incluiTitulo: 'O que inclui exatamente?',
  jaTens: 'Já tens hoje, sem pagar',
  jaTensItens: ['Os teus Tapstar e as suas ligações', 'Estatísticas de leituras', 'Ranking de funcionários'],
  comBusiness: 'Com o Business juntas',
  comBusinessItens: [
    'Todas as tuas avaliações do Google num só sítio',
    'Respostas automáticas com SEO local',
    'Publicações com IA',
    'Métricas da tua ficha: visualizações, chamadas e pedidos de direções',
    'Editar o teu perfil do Google: horários, fotos, serviços e descrição',
    'Mapa SEO: a tua posição e os teus concorrentes',
    'Relatório mensal de resultados',
  ],
  ofertaTitulo: 'De oferta',
  oferta: [
    { titulo: '2 Tapstar de oferta, à tua escolha', texto: 'Escolhes os 2 modelos que preferires, para receberes avaliações novas todos os meses' },
    { titulo: 'Preço bloqueado para sempre', texto: 'Nunca to vamos subir', valor: 'Incluído' },
  ],
  valorTotal: 'Valor total',
  porAno: 'por ano · equivale a 23,92 € por mês',
  incluido: 'Incluído',
  ivaComVies: 'Empresa com NIF português registado no VIES: 287 €, sem IVA.',
  ivaSemVies: 'Sem registo no VIES: 353,01 € com IVA (23 %).',
  garantiaTitulo: 'Garantia de 30 dias',
  garantiaTexto: 'Em 7 dias tens a tua ficha posta em marcha. Se aos 30 dias o teu SEO Score não tiver subido, devolvemos tudo. E ficas com os 2 Tapstar.',
};

export const PROVA = {
  numero: '+1.200',
  texto: 'fichas posicionadas no Google com a Tapstar',
  sub: 'De negócios de bairro a franquias de grandes marcas.',
  setores: ['Restaurantes', 'Cabeleireiros', 'Clínicas dentárias', 'Ginásios', 'Hotéis', 'Oficinas', 'Cafés', 'Lojas', 'Centros de estética', 'Imobiliárias'],
  metricas: [
    { valor: '+40%', texto: 'mais pessoas veem o teu perfil no Google Maps' },
    { valor: '+30%', texto: 'mais chamadas para o teu negócio' },
    { valor: '+30%', texto: 'pessoas novas pedem direções para o teu local' },
  ],
  nota: 'Aumento médio nas fichas dos nossos clientes.',
};

export const TIMELINE = {
  titulo: 'O que acontece depois de pagares',
  passos: (semGmb) => [
    { quando: 'Minuto 0', texto: semGmb
      ? 'Confirmação, fatura e um formulário de 3 minutos. Ligamos a tua ficha do Google contigo.'
      : 'Confirmação, fatura e um formulário de 3 minutos.' },
    { quando: '24 horas', texto: semGmb
      ? 'Diagnóstico da tua ficha, avaliações pendentes respondidas e respostas automáticas ativas.'
      : 'Avaliações pendentes respondidas e respostas automáticas ativas.' },
    { quando: 'Até ao dia 7', texto: 'Ficha otimizada, Tapstar enviados, guia para preparares as publicações do mês em 30 minutos e resumo com o teu novo SEO Score.' },
    { quando: 'Todos os meses', texto: 'Relatório com quantas pessoas veem o teu perfil, as chamadas e os pedidos de direções da tua ficha.' },
    { quando: 'Dia 90', texto: 'Relatório das tuas posições no mapa, antes e depois.' },
  ],
  nota: 'Em cada passo recebes um email. Nunca ficas sem saber o que se passa.',
};

const FAQ_BASE = [
  { q: 'Quando se nota no Google?', a: 'A ficha e as avaliações, desde o primeiro dia. O posicionamento no mapa nota-se com o tempo, normalmente a partir do segundo ou terceiro mês.' },
  { q: 'Porque é uma subscrição, se os meus Tapstar foram pagamento único?', a: 'Os teus Tapstar e o painel para os gerir continuam a ser teus, sem pagar nada. O MyTapstar Business é a versão completa desse painel, para trabalhar a tua ficha do Google todos os dias: respostas automáticas, publicações com IA, mapa SEO e relatório mensal. Como o Google valoriza as fichas sempre ativas, este trabalho é contínuo, e por isso paga-se por ano. Com 2 meses grátis, preço bloqueado para sempre e aviso antes de renovar.' },
  { q: 'Tenho de fazer alguma coisa?', a: 'Só preencher um formulário de 3 minutos e, depois, preparar as publicações do mês com a nossa IA. O resto fazemos nós.' },
  { q: 'As respostas automáticas mexem nas avaliações antigas?', a: 'Não. Respondem às avaliações novas. As que tens pendentes respondemos nós no primeiro dia.' },
  { q: 'Pago IVA?', a: 'Faturamos a partir de Espanha (Speed Data Technologies, S.L.). Se a tua empresa tem NIF português registado no VIES, a fatura sai sem IVA, por autoliquidação, e pagas 287 €. Se não estiver registado, o preço é 353,01 € com IVA (23 %). Podes confirmar o teu NIF no site oficial do VIES da Comissão Europeia.' },
  { q: 'Tenho vários locais. Como funciona?', a: 'O primeiro local custa 287 €. Os seguintes pagam o preço por escalão, mais baixo. Contas como uma só vaga.' },
  { q: 'Garantem que fico em 1.º lugar?', a: 'Não, e desconfia de quem garanta. Quem decide as posições é o Google. O que garantimos é fazer em 7 dias tudo o que o Google tem em conta e mostrar-te, aos 90 dias, as tuas posições antes e depois.' },
  { q: 'O que acontece daqui a 12 meses?', a: 'Avisamos-te 30 e 7 dias antes da renovação. O teu preço fica bloqueado para sempre: nunca to vamos subir. E podes cancelar com um clique.' },
  { q: 'Como funciona a garantia?', a: 'Se 30 dias depois de pagares o teu SEO Score não tiver subido, devolvemos tudo e ficas com os Tapstar. Podes ver o teu SEO Score na plataforma a qualquer momento.' },
];

export const FAQ = {
  titulo: 'Dúvidas frequentes',
  preguntas: (semGmb) => (semGmb
    ? [{ q: 'Ainda não liguei a minha ficha do Google. Posso entrar?', a: 'Sim. Ligamo-la contigo no primeiro dia, em 2 minutos, e nesse momento guardamos o teu SEO Score de partida. A garantia conta a partir daí.' }, ...FAQ_BASE]
    : FAQ_BASE),
};

export const FINAL = {
  restam: (n) => (n == null ? 'Vagas limitadas' : `Restam ${n} vagas`),
  termina: (cierreAt) => {
    const c = partesCierre(cierreAt);
    return `O Plano Google Maps 7 Dias termina a ${c.dia} de ${c.mesLongo}, às ${c.hora}.`;
  },
  duvidas: 'Tens dúvidas?',
  falaCom: 'Fala com o Afaq',
  pagamento: 'Pagamento seguro com Stripe · Fatura com NIF',
};

export const CTA = 'Começar o meu plano';

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const MESES_LONGOS = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto',
  'setembro', 'outubro', 'novembro', 'dezembro'];

// El cierre por defecto (`OFERTA_PT_CIERRE` en settings.py), por si el backend
// no lo manda: así ningún texto de la oferta lleva la fecha escrita a mano.
export const CIERRE_POR_DEFECTO = '2026-11-06T23:59:59Z';

/** Día, mes y hora del cierre en hora de Lisboa. */
export function partesCierre(iso) {
  let d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) d = new Date(CIERRE_POR_DEFECTO);
  // Por partes y con los meses escritos: el `month: 'short'` de pt-PT sale
  // «6/11» en unos navegadores y «6/nov.» en otros, y el diseño dice «6 nov».
  const p = Object.fromEntries(new Intl.DateTimeFormat('pt-PT', {
    day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit',
    hourCycle: 'h23', timeZone: 'Europe/Lisbon',
  }).formatToParts(d).map((x) => [x.type, x.value]));
  const m = Number(p.month) - 1;
  return {
    dia: Number(p.day), mes: MESES[m] || '', mesLongo: MESES_LONGOS[m] || '', hora: `${p.hour}:${p.minute}`,
  };
}

/** «Até 6 nov, 23:59». */
export function formatoCierre(iso) {
  const c = partesCierre(iso);
  return `Até ${c.dia} ${c.mes}, ${c.hora}`;
}

/** «Até 6 nov», sin la hora (los anuncios de dentro de la app). */
export function formatoCierreCurto(iso) {
  const c = partesCierre(iso);
  return `Até ${c.dia} ${c.mes}`;
}

/**
 * Las partidas de «Tudo o que recebes» para N locales, con su valor × N
 * (`VALOR_POR_LOCAL`). `nos`, `plataforma` y `oferta` llevan la misma forma que
 * `TUDO` más su `valor` ya escrito.
 */
export function desglose(locais) {
  const n = Math.max(1, locais || 1);
  const v = VALOR_POR_LOCAL;
  const tapstar = v.tapstarPorLocal * n;
  return {
    nos: TUDO.nos.map((l, i) => ({ ...l, valor: v.servicos[i] ? euros(v.servicos[i] * n) : TUDO.incluido })),
    plataforma: {
      ...TUDO.plataforma,
      titulo: n > 1 ? `${TUDO.plataforma.titulo} · ${n} locais` : TUDO.plataforma.titulo,
      texto: `${TUDO.plataforma.texto} Valor: ${euros(v.plataformaMensal)}/mês por local × 12.`,
      valor: euros(PLATAFORMA_POR_LOCAL * n),
    },
    oferta: TUDO.oferta.map((l, i) => (i === 0
      ? {
        ...l,
        titulo: n > 1 ? `${tapstar} Tapstar de oferta, 2 por local` : l.titulo,
        texto: n > 1
          ? 'Escolhes os modelos que preferires, para receberes avaliações novas todos os meses em cada local'
          : l.texto,
        valor: euros(v.tapstar * n),
      }
      : l)),
  };
}

/** «Restam 43 de 50 vagas», o la versión sin número si el backend no lo manda. */
export function textoVagas(restantes, total = 50) {
  return restantes == null ? `Só ${total} vagas` : `Restam ${restantes} de ${total} vagas`;
}
